module.exports = __webpack_public_path__ + "img/semafor.7085b67e.svg";